import { Button, mergeClasses } from "@fluentui/react-components";
import { useStyles } from "./style";
import { Dismiss28Regular } from "@fluentui/react-icons";
import { InteractionButtonProps } from "./types";
import { useIntl } from "react-intl";

export const RejectInteractionButton = (props: InteractionButtonProps) => {
	const intl = useIntl();
	const { onClick } = props;
	const style = useStyles();

	return (
		<Button
			className={mergeClasses(style.rejectButton, style.button)}
			icon={<Dismiss28Regular />}
			title={intl.formatMessage({ id: "Interaction.Buttons.Reject" })}
			onClick={onClick}
		/>
	);
};
